// MACHINERY V2 (Stroje) — the four glyphs the capability badges paint (M2.9).
// Split out of CapabilityBadge.tsx for the 300-line cap when M2.8 added that
// file's keyboard guard; same shape as forms/FormGlyphs.tsx, which is where the
// v2 stack already keeps a bank of inline SVGs.
//
// Pure presentation: every one of these takes `currentColor` from the button
// around it, so the lit/unlit palette decision stays in CapabilityBadge and is
// not restated here.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

/** MIDAS / AI — the four-point star. */
export const AiGlyph: React.FC<{ size: number }> = ({ size }) => (
  <svg viewBox="0 0 12 12" width={size} height={size} aria-hidden>
    <path d="M6 0.6 L7 5 L11.4 6 L7 7 L6 11.4 L5 7 L0.6 6 L5 5 Z" fill="currentColor" />
  </svg>
);

/** Telemetry — the broadcast arcs over a dot. */
export const TelemetryGlyph: React.FC<{ size: number }> = ({ size }) => (
  <svg
    viewBox="0 0 12 12"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.3"
    strokeLinecap="round"
    aria-hidden
  >
    <circle cx="6" cy="9" r="1.1" fill="currentColor" stroke="none" />
    <path d="M3.7 7.1 a3.2 3.2 0 0 1 4.6 0" />
    <path d="M2.1 5.4 a5.6 5.6 0 0 1 7.8 0" />
  </svg>
);

/** The corner pip's ON state. */
export const Tick: React.FC = () => (
  <svg viewBox="0 0 10 10" width="7" height="7" aria-hidden>
    <path
      d="M2 5.2 L4.2 7.4 L8 3"
      stroke="currentColor"
      strokeWidth="1.6"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** The corner pip's OFF state — absence is an unlit badge, never a hidden one. */
export const Cross: React.FC = () => (
  <svg viewBox="0 0 10 10" width="7" height="7" aria-hidden>
    <path
      d="M2.4 2.4 L7.6 7.6 M7.6 2.4 L2.4 7.6"
      stroke="currentColor"
      strokeWidth="1.6"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);
